import {Department} from './Department';
import {Role} from './Role';

export class User {
  userName: string;
  email: string;
  role: Role[];
  token: string;
  name: string;
  surname: string;
  department: Department;
  employeeId: number;
  authorities: string[];
  manager: boolean;
  admin: boolean;
  selectedRole: Role;
  hr: boolean;
}
